module.exports = __webpack_public_path__ + "static/quote-marks-79b835248b2c6ae0467dc613f02423b5.png";